(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.UploadIconSvg = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var UploadIcon = function UploadIcon() {
    return _react2.default.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        xlink: "http://www.w3.org/1999/xlink",
        width: "56",
        height: "56",
        viewBox: "0 0 56 56"
      },
      _react2.default.createElement(
        "defs",
        null,
        _react2.default.createElement("circle", { id: "a", cx: "28", cy: "28", r: "28" })
      ),
      _react2.default.createElement(
        "g",
        { fill: "none", fillRule: "evenodd" },
        _react2.default.createElement(
          "mask",
          { id: "b", fill: "#fff" },
          _react2.default.createElement("use", { href: "#a" })
        ),
        _react2.default.createElement("use", { fill: "#DFE1E7", href: "#a" }),
        _react2.default.createElement(
          "g",
          { mask: "url(#b)" },
          _react2.default.createElement(
            "g",
            { transform: "translate(13 12)" },
            _react2.default.createElement("rect", { width: "27", height: "30", x: "2", fill: "#47506B", rx: "1" }),
            _react2.default.createElement("rect", { width: "27", height: "30", y: "2", fill: "#757D99", rx: "1" }),
            _react2.default.createElement("rect", {
              width: "19.481",
              height: "1.037",
              x: "4",
              y: "7",
              fill: "#FFF",
              rx: ".519"
            }),
            _react2.default.createElement("rect", {
              width: "19.481",
              height: "1.037",
              x: "4",
              y: "11",
              fill: "#FFF",
              rx: ".519"
            }),
            _react2.default.createElement("rect", {
              width: "19.481",
              height: "1.037",
              x: "4",
              y: "15",
              fill: "#FFF",
              rx: ".519"
            }),
            _react2.default.createElement(
              "g",
              { fill: "#FFF" },
              _react2.default.createElement("path", { d: "M11 26h5v7h-5zM13.5 18l7.5 8H6z" })
            )
          )
        )
      )
    );
  };

  exports.default = UploadIcon;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Tabber/icons/UploadIcon.svg.js
// module id = 2010
// module chunks = 1